$(function () {
    const feedbackForm = $("#FeedbackForm");
    const requestReplyCheckbox = feedbackForm.find("#RequestReply");
    const contactFields = feedbackForm.find("#ContactFields");
    const complaintFields = feedbackForm.find("#ComplaintFields");
    const messageLabelSwitch = feedbackForm.find("#MessageLabelSwitch");
    const radioButtons = feedbackForm.find('input[type=radio][name="type"]');

    // Utility function to toggle visibility
    const toggleVisibility = (element, condition) => {
        condition ? element.show() : element.hide();
    };

    // Initialize optional fields visibility
    toggleVisibility(contactFields, requestReplyCheckbox.is(":checked"));

    // Handle checkbox toggle
    requestReplyCheckbox.click(function () {
        toggleVisibility(contactFields, $(this).is(":checked"));
    });

    // Handle radio button changes
    const handleRadioChange = function () {
        const value = this.value;
        toggleVisibility(complaintFields, value === "Complaint");

        const labelText = {
            Suggestion: "Please tell us more about your suggestion",
            Compliment: "Please tell us more about your positive experience",
            Complaint: "Please tell us more about your experience"
        }[value] || "";

        messageLabelSwitch.text(labelText);
    };

    // Initialize radio button state on load
    radioButtons.filter(":checked").each(function () {
        handleRadioChange.call(this);
    });

    // Bind change event to radio buttons
    radioButtons.change(function () {
        handleRadioChange.call(this);
    });
});